import car_button_01 from './static/car_button_01.png'
import car_button_02 from './static/car_button_02.png'
import car_button_03 from './static/car_button_03.png'
import car_button_04 from './static/car_button_04.png'

const other = [

    {               //  紧急停车按钮 + 824   810
        width: 96,
        height: 126,
        top:420 ,
        left:19598 + 10 ,
        flag:true,
        ani: true,
    },

    {                
        width:1921,
        height:612,
        top:362  + 6 ,
        left:26057 ,
        img: car_button_01,
        rate:15
    },

    {               //  文明推广日 + 820
        width: 1921,
        height:612,
        top:362  + 6 ,
        left:26557 ,
        img: car_button_02,
        rate:15
    },

    {               //  文明推广日 + 820 + 820
        width:1921,
        height:612,
        top:640,  
        left:26057 ,
        img: car_button_03,
        rate:15
    },


    {               //  文明推广日 + 820 + 820
        width:1921,
        height:612,
        top:640,
        left:26557 ,
        img: car_button_04,
        rate:15
    },

]


export default other;